import { Navigate, Outlet } from "react-router-dom";
import { getRequest } from "../../config/axiosConfig";
import { useEffect, useState } from "react";
import Loader from "../loader/loader";
import useAdminProfile from "../../store/admin/profile";

export const ProtectAdminRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const {setProfileData} = useAdminProfile()

  useEffect(() => {
    const checkAdminAuth = async () => {
      try {
        const res = await getRequest({
          url: process.env.REACT_APP_BASE_URL + "auth/admin/me-admin",
        });

        if (res?.success) {
          setIsAuthenticated(true);
          setProfileData(res?.admin)
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.log(error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminAuth();
  }, []);


  if (loading) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  return <Outlet/>;
};

